import { gql } from "@apollo/client";

export const GetUserQuery = gql`
  query GetUser($region: AWSRegions!, $username: ID!) {
    getUser(region: $region, username: $username) {
      firstName
      lastName
      email
      username
      groups
      roles
      status
      attributes
      __typename
    }
  }
`;
